import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UploadFilesProgress from './UploadFilesProgress';
import { uploadFiles } from 'redux/files/FilesActions';

const mapStateToProps = state => ({
  loaded: state.files.loaded,
  total: state.files.total,
});

const mapDispatchToProps = dispatch => ({
  filesActions: bindActionCreators({ uploadFiles }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFilesProgress);



// WEBPACK FOOTER //
// ./src/shared/components/fileDrop/c/uploadFilesProgress/UploadFilesProgressConnector.js